import React from 'react';

var GameControllersFooter = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-game-controllers-footer' }, children));
};

export { GameControllersFooter };
